import { Grid, Stack, Typography } from "@mui/material";
import { MotionContainer, varBounce } from "../../../components/minimal/animate";
import { m } from "framer-motion";
import NoEventsIllustration from "../../../assets/illustrations/NoEventsIllustration";
import { useLocales } from "../../../locales";

export const NoTicketsLeftMsg = () => {
    const { translate } = useLocales();

    return (
        <Grid item sx={{ margin: "20px auto", p: 2, textAlign: "center" }}>
            <Stack alignItems="center" component={MotionContainer}>

                <m.div variants={varBounce().in}>
                    <Typography variant="h4" paragraph sx={{ color: 'text.secondary' }}>
                        {translate('dashboard.events.tickets_sold_out')}
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <NoEventsIllustration
                        sx={{ my: 5 }}
                    />
                </m.div>

            </Stack>
        </Grid>
    )
}
